<template>
  <div>
    <BigHeader  title="Photos & Videos" subtitle="" icon1="" line1="" icon2=""  line2="" icon3=""  line3=""></BigHeader>

    <v-container flex grid-list-xl  class="pb-0">

      <v-layout
        text-xs-center
        wrap
      >

        <v-flex xs12 md10 xl8 offset-md1 offset-xl2  class="mb-3">

          <v-layout
            text-xs-left
            wrap
          >

            <v-flex xs12>

              <v-layout
                text-xs-left
                wrap
              >

                <v-flex id="lisa" xs12 md8>
                  <div class="title ml-3 mb-3">Athena and LISA</div>
                  <v-card style="border-radius: 3px; border: 1px solid lightgray;" class="elevation-0">
                    <v-card-text class="pa-0 ma-0" >
                      <v-responsive :aspect-ratio="16/9" class="black">
                      <iframe  width="100%" height="100%" src="https://www.youtube.com/embed/YyofTn7tZjo" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                      </v-responsive>
                    </v-card-text>
                  </v-card>

                </v-flex>
                <v-flex xs12 md4>

                  <div class="title ml-3 mb-3">Wallpapers</div>

                  <v-card style="border-radius: 3px; border: 1px solid lightgray;     height: calc(100% - 32px);" class="elevation-0">

                    <v-container grid-list-sm fluid>
                      <v-layout row wrap>
                        <v-flex
                          v-for="n in 9"
                          :key="n"
                          xs6
                          d-flex
                        >
                          <v-card flat tile class="d-flex">
                            <v-img
                              :src="`https://picsum.photos/500/300?image=${n * 5 + 10}`"
                              :lazy-src="`https://picsum.photos/10/6?image=${n * 5 + 10}`"
                              aspect-ratio="1"
                              class="grey lighten-2"
                            >
                              <template v-slot:placeholder>
                                <v-layout
                                  fill-height
                                  align-center
                                  justify-center
                                  ma-0
                                >
                                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                </v-layout>
                              </template>
                            </v-img>
                          </v-card>
                        </v-flex>
                      </v-layout>
                    </v-container>

                  </v-card>

                </v-flex>

              </v-layout>

            </v-flex>
          </v-layout>
        </v-flex>

      </v-layout>

    </v-container>

<div style="height:600px;"></div>
  </div>
</template>

<script>

  import BigHeader from '../components/BigHeader'

  export default {
    components: {
      BigHeader
    },
    data () {
      return {


      }
    }
  }
</script>
